import request from '../utils/request';

// 点赞记录API
export const likeRecordApi = {
  // 获取点赞记录分页（管理员）
  getLikeRecordList: (params) => request.post('/like-record/page',  params ),

  // 获取点赞统计数据（若后端未提供，将在 slice 内本地计算或使用兜底）
  getLikeStatistics: (params) => request.get('/like-record/statistics', { params }),

  // 获取内容互动数据（若后端未提供，将在 slice 内本地计算或使用兜底）
  getContentInteractionData: (params) => request.get('/like-record/content-interaction', { params }),

    // 点赞统计概览（管理员）
    getLikeStatsOverview: (data) => request.post('/like-record/stats/overview', data),

  // 识别违规点赞
  identifyViolationLikes: (data) => request.post('/like-record/identify-violations', data),

  // 处理违规点赞
  processViolationLikes: (data) => request.post('/like-record/process-violations', data),

  // 导出点赞记录
  exportLikeRecords: (params) => request.get('/like-record/export', { params, responseType: 'blob' })
  ,

  // 点赞统计概览（POST）
  getLikeStatsOverview: (data) => request.post('/like-record/stats/overview', data || {})
};